import { useForm } from '@mantine/form';
import { mergeWith } from 'lodash';

import { TSDViewConsignmentFormValues } from '@e-origin/contracts';

import { useUpdateTSD } from '@hooks/tsd';
import { useTSDViewEditGoodsItemFormInitializer } from './GoodsItemsList/EditGoodsItem';
import { useTSDViewHouseFormInitializer } from './HousesList/EditHouse';

export const useTSDViewConsignmentFormInitializer = ({ tsd }) => {
  const updateTSDMutation = useUpdateTSD();

  const { buildHouseValues } = useTSDViewHouseFormInitializer({
    houseConsignmentIdx: null,
    consignmentForm: null,
    isMaster: false,
    onSave: null,
    onHide: null,
  });

  const { buildGoodsItemValues } = useTSDViewEditGoodsItemFormInitializer({
    goodsItemIdx: null,
    isMaster: false,
    houseConsignmentIdx: null,
    consignmentForm: null,
    onSave: null,
    onHide: null,
  });

  const buildConsignmentValues = (t) => ({
    master: tsd?.consignment?.master
      ? {
          ...buildHouseValues(tsd.consignment.master),
          consignmentItems: tsd.consignment.master.consignmentItems?.map((item) => buildGoodsItemValues(item)) || [],
        }
      : null,
    houseConsignment: (tsd?.consignment?.houseConsignment || []).map((house) => ({
      ...buildHouseValues(house),
      consignmentItems: house.consignmentItems?.map((item) => buildGoodsItemValues(item)) || [],
    })),
  });

  const consignmentForm = useForm<TSDViewConsignmentFormValues>({
    initialValues: buildConsignmentValues(tsd),
  });

  const onSubmit = async (values) => {
    updateTSDMutation.mutateAsync({
      tsd: mergeWith({ _id: tsd._id }, { consignment: { ...values }, customer: tsd.customer, name: tsd.name }, (objValue, srcValue) =>
        Array.isArray(srcValue) ? srcValue : undefined,
      ),
    });
  };

  return { buildConsignmentValues, consignmentForm, onSubmit };
};
